import ApiService from '@/services/api.service'

import type { AxiosResponse, AxiosRequestConfig } from 'axios'
import type { UserSettings } from '@/types/services/user_settings'

class UserSettingsService {
  /**
   * Get User Settings
   */
  static getUserSettings(): Promise<AxiosResponse<UserSettings>> {
    const config: AxiosRequestConfig = {
      url: ApiService.getResourceUrl(`/api/v2/users/user_settings`),
      method: 'get',
    }

    return ApiService.customRequest(config)
  }

  /**
   * Update User Settings
   **/
  static updateUserSettings(
    data: Partial<UserSettings>
  ): Promise<AxiosResponse<UserSettings>> {
    return ApiService.patch(`/api/v2/users/user_settings`, data)
  }
}

export default UserSettingsService
